import bootstrap from 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Toaster from '../../pages/Toaster/Toaster.jsx';
import './GlkHeader.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt, faBars, faUserPlus, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import logo from '../../assets/images/glk_member_area.svg';
import icon_logo from "../../assets/images/glk_member_area_mobile.svg";
import { useTranslation } from "react-i18next";
import i18n from '../../i18n/i18n.jsx';
import { useNavigate, useLocation, Link } from "react-router-dom";
import Button from 'react-bootstrap/Button';
import Badge from 'react-bootstrap/Badge';
import { getHomeDetails, generateUserPin, getMessageCount } from '../../pages/home/homeServices.jsx';
import { useContext, useEffect, useState, useLayoutEffect, useRef } from 'react';
import { LoginContext } from '../../context/loginContext.jsx';
import Menubar from '../../pages/home/menuBar.jsx';
import userIcon from '../../assets/images/user-icon01.png';
import LogoutPopup from './logoutPopup.jsx';
import { Dropdown } from 'react-bootstrap';
import TooltipWrapper from '../TooltipWrapper.jsx';
import UserPinModal from './userPinModal.jsx';
import DarkModeCustomToggle from '../../utils/darkModeCustomToggle.jsx';

function MemberHeader() {
  const [homeDetails, setHomeDetails] = useState(null);
  const [mobileMenuVisible, setMobileMenuVisible] = useState(false);
  const [show, setShow] = useState(false);
  const [userPin, setUserPin] = useState(null);
  const [showUserPinModal, setShowUserPinModal] = useState(false)
  const [showDropdown, setShowDropdown] = useState(false);
  const [messageAndSuggestionCount, setMessageAndSuggestionCount] = useState();

  const [toastMessage, setToastMessage] = useState('');
   const [toastType, setToastType] = useState('');
   const toastRef = useRef();

   const handleShowToast = (msg, type) => {
       setToastMessage(msg);
       setToastType(type);
       setTimeout(() => {
           const toastElement = toastRef.current;
           const options = {
               animation: true,
               autohide: true,
               delay: 5000,
           };
           if (toastElement) {
               const bootstrapToast = new bootstrap.Toast(toastElement, options);
               bootstrapToast.show();
           }
       }, 100);
   };

  const { t } = useTranslation();
  const languageCode = i18n.language;

  const homeDetailsRef = useRef(homeDetails);

  let navigate = useNavigate();
  let {
    loginData: {
      memberDetails,
      alias,
      accessToken,
      messageCount
    },
    dispatch,
    headerProps,
    headerDispatch
  } = useContext(LoginContext);

  const { showMenubar, myProfileUrl, isMessenger, isSuggestion } = headerProps;

  const token_lang = {
    language: languageCode,
    accessToken
  }
  useEffect(() => {
    homeDetailsRef.current = homeDetails;
  }, [homeDetails]);


  useEffect(() => {
    refreshHomeDetails();

    let header_menu = document.querySelector('#root');
    let menuContainer = document.querySelector('.menubar_container');

    let scrollPosition = 0;
    window.addEventListener('scroll', () => {
      let currentScrollPosition = window.scrollY;

      if (currentScrollPosition > scrollPosition && currentScrollPosition >= 100 && !header_menu.classList.contains('sticky_menu')) {
        header_menu.classList.add('sticky_menu');
      }
      else if (currentScrollPosition < scrollPosition && header_menu.classList.contains('sticky_menu')) {
        if (currentScrollPosition < 80) {
          setMobileMenuVisible(false);
          header_menu.classList.remove('sticky_menu');
          menuContainer?.classList.remove('mobile_nav_show');
        }
      }
      scrollPosition = currentScrollPosition;
    });

  }, [languageCode, accessToken]);

  const updateHomeDetailsAvatar = (avatarValue) => {
    const nextHomeDetails = { ...(homeDetailsRef.current || headerProps?.homeDetails || {}), avatar: avatarValue };
      homeDetailsRef.current = nextHomeDetails;
      setHomeDetails(nextHomeDetails);
      headerDispatch({ type: 'HOMEDETAILS', data: nextHomeDetails });
  };

  const refreshHomeDetails = () => {
    if (headerProps?.homeDetails == undefined || headerProps?.homeDetails == '') {
      getHomeDetails(token_lang).then((res) => {
        if (res?.status === 200) {
          setHomeDetails(res.data);
          setMessageAndSuggestionCount({ suggestions: res?.data.suggestions, messages: res?.data?.messages })
          headerDispatch({ type: 'HOMEDETAILS', data: res.data });
          const unreadMessagesByAvailableUsers = res?.data?.unreadMessagesByAvailableUsers || 0;
          const unreadMessagesByAllUsers = res?.data?.unreadMessagesByAllUsers || 0;
          dispatch({
            type: "MESSAGE_COUNT",
            data: { unreadMessagesByAvailableUsers, unreadMessagesByAllUsers, messageCount },
          });
        }
      });
    }
  }

  useEffect(() => {
    if (memberDetails?.memberStatus !== 'REGISTRATION') {
      const intervalId = setInterval(() => {
        getMessageCount(token_lang).then((res) => {
          if (res?.status === 200) {
            setMessageAndSuggestionCount(res?.data)
            let updateMsgCount = { ...homeDetails, suggestions: res?.data?.suggestions, messages: res?.data?.messages }
            headerDispatch({ type: 'HOMEDETAILS', data: updateMsgCount });
          }
        });
      }, 60000);
      return () => clearInterval(intervalId);
    }
  }, [homeDetails]);

// Optimistic Update Listener using Context API
useEffect(() => {
    if (headerProps?.homeDetails) {
        setMessageAndSuggestionCount(prev => ({
            ...prev,
            suggestions: headerProps.homeDetails.suggestions !== undefined 
                ? headerProps.homeDetails.suggestions 
                : prev?.suggestions,
            messages: headerProps.homeDetails.messages !== undefined 
                ? headerProps.homeDetails.messages 
                : prev?.messages
        }));
    }
}, [headerProps?.homeDetails?.suggestions, headerProps?.homeDetails?.messages]);

  const toggleMobileMenu = () => {
    setMobileMenuVisible(!mobileMenuVisible);
  };

  const logout = (e) => {
    setShow(false);
    localStorage.removeItem('accessToken');
    headerDispatch({ type: 'HOMEDETAILS', data: '' });
    headerDispatch({ type: 'MYPROFILE', data: '' });
    dispatch({ type: 'ACCESS_TOKEN', data: '' })
    dispatch({ type: 'LOGIN', data: null });
    dispatch({ type: 'MEMBER_DETAILS', data: null });
    dispatch({ type: 'IS_CONFIRM_MAIL_POPUP', data: true });
    navigate('/')
  }

  const location = useLocation();

const getUserPin = (isShowPopup) => {
      generateUserPin(token_lang).then((response) => {
        if (response?.status === 200 && response?.data) {
          // Success: Set PIN, and only show popup if isShowPopup is true
          setUserPin(response.data);
          
          if (isShowPopup) {
            window.history.pushState({ openModel: true }, ''); 
            setShowUserPinModal(true);
          }
        } else {
          // Failure: Reset PIN state
          setUserPin(null);
          
          // Show error toaster ONLY if the user actually clicked to open the popup
          if (isShowPopup) {
             handleShowToast(t('member.header.userPinFetchError'), 'error');
          }
        }
      }).catch((error) => {
          // Network Error: Reset PIN state
          setUserPin(null);
          
          if (isShowPopup) {
             handleShowToast(t('member.header.userPinFetchError'), 'error');
          }
      });
    };

  useEffect(() => {
    const handlePopState = () => {
      if (showUserPinModal) {
        setShowUserPinModal(false);
      };
    };
    window.addEventListener('popstate', handlePopState);
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [showUserPinModal]);

  const handleDropdownToggle = (isOpen) => {
    const newState = isOpen !== undefined ? isOpen : !showDropdown;
    setShowDropdown(newState);
    getUserPin(false);
  };

  const closeUserPinPopup = () => { setShowUserPinModal(false) }

  const handleMobileDropdownClick = (e) => {
  e.stopPropagation();
  handleDropdownToggle();
  setMobileMenuVisible(false);
  };

  useLayoutEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
      document.body.setAttribute('class', '');
      if (window.location.pathname.split("/")[2]) {
        document.body.classList.add(window.location.pathname.split("/")[2]);
      }
    }, 0);
  }, [location.pathname]);
  
  function navigateToPage(path) {
    const pathUrl = {
      suggestions: '/suggestions/suggestions',
      messenger: '/suggestions/messenger',
      partnership: '/partnership/myprofile',
      friendship: '/friendship/myprofile',
      overview: '/home',
    };

    navigate(pathUrl[path]);
  }

  useEffect(() => {
    if (homeDetails) {
      const updatedMessagesCount = { ...homeDetails, messages: messageCount };
      setHomeDetails(updatedMessagesCount);
    }
  }, [messageCount]);

  async function blobUrlToBase64(blobUrl) {
    try {
      const response = await fetch(blobUrl);
      const blob = await response.blob();

      return await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      console.error("Error converting blob to base64:", error);
      return null;
    }
  }

  useEffect(() => {
    const isProfileAvatarUpdate = ['overwrite', 'partnership', 'friendship'].includes(myProfileUrl?.type);
    if (myProfileUrl?.img && isProfileAvatarUpdate) {
      updateProfileImage(myProfileUrl.img);
      return;
    }
     if (isProfileAvatarUpdate && myProfileUrl?.img === null) {
      updateHomeDetailsAvatar(null);
      return;
    }
    if (myProfileUrl?.type === 'refresh' || myProfileUrl == '') {
      homeDetailsRef.current = headerProps?.homeDetails;
      setHomeDetails(headerProps?.homeDetails)
    }
  }, [myProfileUrl])

  const updateProfileImage = (imageUrl) => {
    blobUrlToBase64(imageUrl).then(base64 => {
     if (base64) {
        updateHomeDetailsAvatar(base64);
      }
    });
  }

  useEffect(() => {
    const handlePopState = () => {
      if (show) {
        setShow(false);
      };
    };
    window.addEventListener('popstate', handlePopState);
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [show]);

  return (
    <>
      <header className="app_header">
        {memberDetails?.memberStatus === 'REGISTERED' ?
          <>
            <button className='main_logo' onClick={() => navigateToPage('overview')}>
              <img className='full_logo' src={logo} alt="Gleichklang logo" />
              <img className='small_logo' src={icon_logo} alt="Gleichklang Icon" />
              <span>| Community</span>
            </button>
            <div className='member_header'>
              <div className='home_btns'>
                {isSuggestion ? null :
                  <Button onClick={() => navigateToPage('suggestions')} className='suggest_btn' variant="success">
                    <FontAwesomeIcon icon={faUserPlus} />
                    {t('member.menubar.suggestions')}
                    <Badge bg="warning">{messageAndSuggestionCount?.suggestions}</Badge>
                    <span className="visually-hidden">{t('member.header.unread_suggestions')}</span>
                  </Button>}
                {isMessenger ? null :
                  <Button onClick={() => navigateToPage('messenger')} className='msg_btn' variant="primary">
                    <FontAwesomeIcon icon={faEnvelope} />
                    {t('member.menubar.messages')}
                    <Badge bg="warning">{messageAndSuggestionCount?.messages}</Badge>
                    <span className="visually-hidden">{t('member.header.unread_messages')}</span>
                  </Button>}
              </div>
              <div className='header_member_info'>
                <div>
                  {memberDetails ?
                    <button
                      style={{ background: "none", border: "none" }}
                      aria-label={`${t('member.header.hello')} ${alias}`}
                      className='greeting'
                      // Pale Moon Fix: Prevent event bubbling when clicking the user greeting text. 
                      // Without this, the click event propagates to parent listeners, instantly closing the dropdown.
                      onClick={handleMobileDropdownClick}>
                      {t('member.header.hello')} {alias}
                    </button>
                    : null}
                </div>
                <Dropdown
                  className='dropdown-menu-image'
                  onClick={() => getUserPin(false)}
                  show={showDropdown}
                  onToggle={handleDropdownToggle}
                >
                  {/* Pale Moon Fix: Prevent event bubbling when clicking the profile avatar. */}
                  {/* Without this, the click event propagates to parent listeners, instantly closing the dropdown. */}
                  <Dropdown.Toggle 
                    as="div"
                    id="dropdown-basic" 
                    className="p-0 border-0 bg-transparent" 
                    bsPrefix="custom-toggle"
                  >
                    <div className="header_avatar" onClick={handleMobileDropdownClick}>
                      <img
                        className="avatar"
                        src={
                          homeDetails && homeDetails.avatar !== null
                            ? homeDetails.avatar.includes(';base64,') ? homeDetails.avatar : "data:image/jpeg;base64," + homeDetails.avatar
                            : userIcon
                        }
                        alt={`Avatar ${memberDetails?.alias}`}
                      />
                    </div>
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {memberDetails?.partnershipActive && (
                      <Dropdown.Item className={`dropdown-item dropdown_on_image ${myProfileUrl?.type === 'partnership' ? 'active' : ''}`} onClick={() => navigateToPage('partnership')}>{t('member.header.userProfilePartner')}</Dropdown.Item>
                    )}
                    {memberDetails?.friendshipActive && (
                      <Dropdown.Item className={`dropdown-item dropdown_on_image ${myProfileUrl?.type === 'friendship' ? 'active' : ''}`} onClick={() => navigateToPage('friendship')} >{t('member.header.userProfileFriend')}</Dropdown.Item>
                    )}
                    {(memberDetails?.partnershipActive || memberDetails?.friendshipActive) && (
                      <Dropdown.Divider />
                    )}
                    <Dropdown.Item className={`dropdown-item dropdown_on_image ${window.location.pathname === '/teilnehmer/membership/personaldata' ? 'active' : ''}`} onClick={() => navigate('/membership/personaldata')}>{t('member.header.personaldatas')}</Dropdown.Item>
                    <Dropdown.Item className={`dropdown-item dropdown_on_image ${window.location.pathname === '/teilnehmer/personal-details/gallery' ? 'active' : ''}`} onClick={() => navigate('/personal-details/gallery')}>{t('member.header.addgalleries')}</Dropdown.Item>
                    <Dropdown.Item className={`dropdown-item dropdown_on_image ${window.location.pathname === '/teilnehmer/personal-details/audios' ? 'active' : ''}`} onClick={() => navigate('/personal-details/audios')}>{t('member.header.addaudio')}</Dropdown.Item>
                    <Dropdown.Divider />
                    <Dropdown.Item className='dropdown-item dropdown_on_image' href="#" onClick={() => getUserPin(true)}>{t('member.header.userPinProfile')}{userPin?.pin}</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
            <div id="headerButtons" className='header_bts'>
              <DarkModeCustomToggle/>
              <TooltipWrapper tooltipText={t('member.menubar.menu')} tooltipId="tooltip-menu" placement="bottom" modalVisible={mobileMenuVisible}>
                <button className='toggle_menu' id="toggle_menu" aria-label={t('member.menubar.menu')} onClick={() => toggleMobileMenu()}>
                  <FontAwesomeIcon icon={faBars} />
                </button>
              </TooltipWrapper>

              <TooltipWrapper tooltipText={t('member.header.logout')} tooltipId="tooltip-logout" placement="bottom" modalVisible={show}>
                <button className='header_logout' aria-label={t('member.header.logout')} onClick={() => { setShow(true) }}>
                  <FontAwesomeIcon icon={faSignOutAlt} />
                </button>
              </TooltipWrapper>
            </div>
          </>
          : null}

      </header>
      {memberDetails?.memberStatus === 'REGISTERED' && (showMenubar == null || showMenubar)
        ?
        <Menubar
          setMobileMenuVisible={setMobileMenuVisible}
          mobileMenuVisible={mobileMenuVisible}
          handleLogout={() => { setShow(true) }}
        /> :
        ''}
      {show ? <LogoutPopup
        isPreRegistration={false}
        step={1}
        show={show}
        setShow={setShow}
        logout={logout}
        alias={alias}
      /> : ''}
      <UserPinModal
        showUserPinModal={showUserPinModal}
        alias={alias}
        closeUserPinPopup={closeUserPinPopup}
        userPin={userPin}
      />
      <Toaster toastMessage={toastMessage} toastRef={toastRef} type={toastType}/>
    </>
  )
}

export default MemberHeader;